
import Navbar from "./Navbar.vue";
import PageHeader from "./PageHeader.vue";
import Avatar from "./Avatar.vue";

import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/store";

export default defineComponent({
  name: "EHeader",
  components: {
    Navbar,
    PageHeader,
    Avatar,
  },
  setup() {
    const route = useRoute();
    const userStore = useUserStore();
    const userEmail = userStore.getEmail;
    return {
      route,
      userEmail,
    };
  },
});
